import {cx} from '@emotion/css';
import React, {ReactElement, ReactNode} from 'react';
import styles from './Field.styles';

interface Props {
  assistiveMessage?: ReactNode;
  isDisabled?: boolean;
  className?: string;
}

function AssistiveText({assistiveMessage = '', isDisabled, className}: Props): ReactElement | null {
  return assistiveMessage ? (
    <div className={cx(styles.assistiveText(false, false, isDisabled), className, 'fieldAssistiveText')}>
      {assistiveMessage}
    </div>
  ) : null;
}

export default AssistiveText;
